export function Publications() {
  return (
    <div>
      <h2 className="font-extrabold">PUBLICATIONS</h2>
      <ul className="mt-4 flex flex-col flex-cols-1 text-slate-400 space-y-10">
        <li>
          <p className="text-xs font-extrabold text-slate-500">
            BORGARS, J. ET AL. (2025)
          </p>
          <h3>
            <a
              href="https://doi.org/10.1007/978-3-031-98694-9_15"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-200 hover:text-slate-300 font-semibold"
            >
              Intraoperative Segmentation Through Deep Learning and Mask
              Post-processing in Laparoscopic Liver Surgery
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            LECTURE NOTES IN COMPUTER SCIENCE
          </h4>
          <p className="text-sm mt-3">
            Presents advancements in intraoperative segmentation in laparoscopic
            liver surgery through the use of post-processing techniques. Also
            presents an in-depth ablation study of deep learning models and
            hyperparameters.
          </p>
        </li>

        <li>
          <p className="text-xs font-extrabold text-slate-500">
            ABBAS, A.K. ET AL. (2025)
          </p>
          <h3>
            <a
              href="https://doi.org/10.1007/978-3-031-98691-8_16"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-200 hover:text-slate-300 font-semibold"
            >
              Midline-Constrained Loss in the Anatomical Landmark Segmentation
              of 3D Liver Models
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">
            LECTURE NOTES IN COMPUTER SCIENCE
          </h4>
          <p className="text-sm mt-3">
            Presents the novel Midline Loss function for use in the segmentation
            of preoperative 3D Liver models extracted from CT/MRI scans.
            Achieves best-in-class results on the P2ILF dataset.
          </p>
        </li>

        <li>
          <p className="text-xs font-extrabold text-slate-500">
            CHEN, T. ET AL. (2025)
          </p>
          <h3>
            <a
              href="https://doi.org/10.3389/978-2-8325-5137-0"
              target="_blank"
              rel="noopener noreferrer"
              className="text-slate-200 hover:text-slate-300 font-semibold"
            >
              Preoperative to Intraoperative Deformed Liver Volumes Registration
            </a>
          </h3>
          <h4 className="mt-1 text-xs font-extrabold">FRONTIERS</h4>
          <p className="text-sm mt-3">
            Utilises the Finite Element Method to simulate the deformation of
            livers using 3D Liver models extracted from scans, creating
            synthetic data with a view to be used in aiding the training of
            registration models.
          </p>
        </li>
      </ul>
    </div>
  );
}
